import { Box, LinearProgress, Tab, Tabs } from '@mui/material'
import { useEffect, useState } from 'react'
import { Link, Outlet, Route, Routes, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import 'utils/global.scss'
import StudentSchools from './StudentSchools'
import StudentProfile from './StudentProfile'
// import { get } from 'store/application/student-applications'

const PROFILE = 0
const SCHOOLS = 1

const getTabIndex = path => {
  const [tabName] = path.split('/')
  const i = ['profile', 'schools'].indexOf(tabName)
  return i < 0 ? 0 : i
}

export default function ApplicationDetailTabs({ applicationRecord, setApplicationRecord, clientSchools, academicYears }) {
  const { t } = useTranslation()
  const theme = useSelector(state => state.session.appearance)
  const { applicationId, '*': tabName } = useParams()
  const [tabIndex, setTabIndex] = useState(getTabIndex(tabName))

  useEffect(() => {
    setTabIndex(getTabIndex(tabName))
  }, [tabName])
  const basePath = `/admission/application-list/${applicationId}`

  if (!applicationRecord) return <LinearProgress />

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', displayPrint: 'none' }}>
        {applicationId && (
          <Tabs
            value={tabIndex}
            TabIndicatorProps={{ style: { background: 'primary', fontFamily: 'Roboto, sans-serif' } }}
          >
            <Tab
              sx={{ color: tabIndex === 0 && 'primary !important' }}
              className={tabIndex === 0 ? `tab-item-selected` : `tab-item-${theme}`}
              label={t('Profile')}
              value={PROFILE}
              component={Link}
              to={`${basePath}/profile`}
            />
            <Tab
              sx={{ color: tabIndex === 1 && 'primary !important' }}
              className={tabIndex === 1 ? `tab-item-selected` : `tab-item-${theme}`}
              label={t('Schools')}
              value={SCHOOLS}
              component={Link}
              to={`${basePath}/schools`}
            />
          </Tabs>
        )}
      </Box>
      <Routes>
        <Route path="" element={<Outlet />}>
          <Route path="" element={<StudentProfile applicationRecord={applicationRecord} setApplicationRecord={setApplicationRecord} academicYears={academicYears} />} />
          <Route path="profile/*" element={<StudentProfile applicationRecord={applicationRecord} setApplicationRecord={setApplicationRecord} academicYears={academicYears} />} />
          <Route path="schools/*" element={<StudentSchools applicationRecord={applicationRecord} setApplicationRecord={setApplicationRecord} clientSchools={clientSchools} />} />
        </Route>
      </Routes>
    </Box>
  )
}
